export default __webpack_public_path__ + "static/media/the_venue_3.e8633286.png";